<div class="backDrop" *ngIf="showDialog$ | async">
    <div class="modal-dialog modal-s">
        <div class="modal-content ">
            <div>
                <!-- Modal Header -->
                <div class="modal-header ">
                    <h4 class="modal-title">Request new sub company creation</h4>
                </div>

                <!-- Modal body -->
                <div class="modal-body ">
                    <!--inhoud-->
                    <div class="custom-form" [formGroup]="subcompanyCreateForm">
                        <div>
                            <label class="form-label">Name of subcompany</label>
                            <dx-text-box [formControlName]="'name'" placeholder="Name...">
                            </dx-text-box>
                            <label class="form-label">Email</label>
                            <dx-text-box [formControlName]="'email'" placeholder="Enter a valid email address...">
                            </dx-text-box>
                        </div>
                        <div>
                            <br>
                            <div style="width: 35vw">Please read: The creation of a subcompany allows for the creation of a new company with its own users and configuration. If the current company does not have any subcompanies yet, then all links/logins/configurations will be
                                tranferred to the first created subcompany.</div>
                            <br>
                            <div style="width: 35vw">The creation of a subcompany has to be approved by an admin. You'll be informed by email if the request is accepted</div>
                        </div>
                    </div>
                </div>

                <!-- Modal footer -->
                <div class="modal-footer">
                    <button type="button" class="btn btn-success" (click)="sendRequest()">
						Send request
					</button>
                    <button type="button" class="btn btn-primary" (click)="cancel()">
						Cancel
					</button>
                </div>
            </div>
        </div>
    </div>
</div>
